import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';
import { useClientAuth } from '@stitch-fix/sf-next';
import { EmptyState, IllustrationMdEmptyBox, ResponsiveSection, Toast } from '@stitch-fix/mode-react';
import { useState } from 'react';
import { EmailPreferences } from './EmailPreferences/EmailPreferences';
import { PreferenceCenter } from './PreferenceCenter/PreferenceCenter';
import { useGetClientEmailOptOutQuery } from './GetClientEmailOptOut';
import { Layout } from '../../../components/Layout';
import { LoadingSpinner } from '../../../components/LoadingSpinner';
export type NotificationsPageProps = {
  isiOSView: boolean;
};
export const getServerSideProps: GetServerSideProps<NotificationsPageProps> = async ({
  req
}) => {
  return {
    props: {
      isiOSView: req.headers.stitchfix_mobile_app_version != null
    }
  };
};
const NotificationSettings: NextPage<NotificationsPageProps> = ({
  isiOSView
}: NotificationsPageProps) => {
  const {
    data,
    loading
  } = useGetClientEmailOptOutQuery();
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const {
    authStatus
  } = useClientAuth();
  const loggedIn = authStatus === 'authenticated';
  const showEmptyState = !loading && !data && loggedIn;
  const showEmailPreferencesPageContent = !loading && data;
  return <Layout viewEventTrackingName="notifications_settings" forceHideHeaderFooter={isiOSView}>
      <Head>
        <title>Email Notification Settings | Stitch Fix</title>
        <meta name="description" content="Stitch Fix Email Notification Settings" />
      </Head>
      {loading && <LoadingSpinner />}
      {showEmptyState && <ResponsiveSection width="medium">
          <EmptyState as="section" heading="Unable to load this page" image={<IllustrationMdEmptyBox width={240} />} primaryAction={{
        children: 'Try again',
        onClick: () => window.location.reload()
      }}>
            Something went wrong. Please try again.
          </EmptyState>
        </ResponsiveSection>}
      {showEmailPreferencesPageContent && (loggedIn ? <PreferenceCenter data={data} setShowErrorToast={setShowErrorToast} setShowSuccessToast={setShowSuccessToast} /> : <EmailPreferences data={data} setShowErrorToast={setShowErrorToast} setShowSuccessToast={setShowSuccessToast} />)}
      <Toast isOpen={showSuccessToast} onClose={() => setShowSuccessToast(false)}>
        Your notification preferences have been saved.
      </Toast>
      <Toast isOpen={showErrorToast} onClose={() => setShowErrorToast(false)}>
        There was a problem saving your information, please try again.
      </Toast>
    </Layout>;
};
export default NotificationSettings;